<template>
  <vue-page-wrapper :title="htmlTitle" :bread-crumbs="breadCrumbItems">
    <select-client
      ref="selectCient"
      :client.sync="client"
      @updateData="logKey += 1"
    ></select-client>

    <v-row v-if="client">
      <v-col sm="12">
        <client-detail
          @triggerLogForm="triggerLogForm($event)"
          :key="logKey"
          :clientDetail="client"
          :refresh-contact="refreshContact"
        ></client-detail>
      </v-col>
      <v-col sm="12" class="pt-0">
        <client-activity
          :clientSlug="client.slug"
          class="mt-3"
          @triggerLogForm="triggerLogForm($event)"
          :key="logKey"
          @linkToChain="
            (serviceChainInformation = $event),
              triggerLogForm({ formType: 'Communication', ...$event })
          "
        ></client-activity>
      </v-col>
    </v-row>
    <v-navigation-drawer
      width="720"
      v-model="showLogForm"
      right
      temporary
      fixed
      clipped
    >
      <template v-slot:prepend>
        <v-card flat>
          <vue-card-title
            :title="`${logType} Log`"
            :subtitle="`Here you can create ${logType} log with client.`"
            :icon="$getIcon('mdiFileDocumentEdit')"
            closable
            dark
            @click="showLogForm = false"
            @close="showLogForm = false"
          >
          </vue-card-title>
          <v-divider></v-divider>
        </v-card>
      </template>

      <log-form
        :client="client"
        @refreshContactList="refreshContact += 1"
        v-if="showLogForm"
        :contactPerson="contactPerson"
        @contactPersonUpdate="contactPerson = $event"
        :contactPersonList="contactPersonList"
        :service-chain-information="serviceChainInformation"
        @close="(showLogForm = false), (serviceChainInformation = {})"
        @success="successForm"
      ></log-form>
    </v-navigation-drawer>
  </vue-page-wrapper>
</template>
<script>
//TODO@Rohit: This page has not been used. The contents here have been moved to client detail page. Remove this page after validating errors.
import SelectClient from "@/components/crm/client/components/selectClient";
import ClientDetail from "@/components/crm/client/components/clientDetail";
import ClientActivity from "@/components/crm/client/components/clientActivityLogs";
import LogForm from "@/components/crm/client/components/logForm";

export default {
  created() {
    if (this.$route.query.client) {
      this.fetchSpecificClient(this.$route.query.client);
    }
  },
  watch: {
    client() {
      this.contactPerson = undefined;
      this.logKey += 1;
    }
  },
  data() {
    return {
      refreshContact: 1,
      htmlTitle: "Client action page",
      breadCrumbItems: [
        { text: "CRM", disabled: false, to: "crm-home" },
        { text: "Client Action", disabled: true }
      ],
      client: null,
      contactPerson: null,
      contactPersonList: [],
      showLogForm: false,
      logType: "Communication",
      logKey: 1,
      serviceChainInformation: {}
    };
  },
  components: {
    LogForm,
    SelectClient,
    ClientDetail,
    ClientActivity
  },
  methods: {
    triggerLogForm(event) {
      if (event.formType === "Communication" && !event.contactPerson) {
        return this.$store.dispatch("shell/showSnackbar", {
          text: `Please Select Contact Person.`,
          color: "red"
        });
      }
      this.logType = event.formType;
      this.showLogForm = true;
      this.contactPerson = event.contactPerson;
      if (event.contactPersonList) {
        this.contactPersonList = event.contactPersonList;
      }
    },
    fetchSpecificClient(slug) {
      this.$axios.get(`/api/v1/crm/clients/${slug}/`).then(({ data }) => {
        this.client = data;
      });
    },
    successForm() {
      this.$refs.selectCient.getRecentClient();
      this.showLogForm = false;
      this.logKey = this.logKey + 1;
      this.serviceChainInformation = {};
    }
  }
};
</script>
